import { useIsomorphicLayoutEffect } from "./use-isomorphic-layout-effect";

export type LookbookViewMode = "feed" | "story";

export interface LookbookViewModes {
  mobile: LookbookViewMode;
  desktop: LookbookViewMode;
}

export function useThemeClass(
  mode: "desktop" | "mobile" | null,
  viewModes: LookbookViewModes,
) {
  useIsomorphicLayoutEffect(() => {
    if (mode) {
      const htmlTag = document.querySelector("html");

      if (viewModes[mode] === "feed") {
        htmlTag?.classList.remove("theme--story");
        htmlTag?.classList.add("theme--feed");
      } else {
        htmlTag?.classList.remove("theme--feed");
        htmlTag?.classList.add("theme--story");
      }
    }
  }, [mode, viewModes]);
}
